import 'core-js/es/object/assign';
import defaultEnv from '../config/environment-default';

const current = [];
let environments = {};

function get() {
  return environments;
}

function is(name) {
  return current.indexOf(name) > -1;
}

function getNames() {
  return current;
}

function isDevelopment() {
  return is('development');
}

function isLocal() {
  return is('local');
}

function isTest() {
  return is('test');
}

function isStage() {
  return is('stage');
}

function isProduction() {
  return is('production');
}

function initialize(localEnvironmentConfig) {
  const configurations = [];

  if (!localEnvironmentConfig) {
    // if no environment config is specified, maybe it is already in the window-object?
    if (window.agsw && window.agsw.environment) {
      environments = window.agsw.environment;
    } else { // no environment config anywhere? use the default one
      // eslint-disable-next-line no-console
      console.log('NOTICE: You should initialize the environment with a local environment-config before using it.\nFalling back to the default environment. This is OK when inside an app, that will be embedded anyway.');
      environments = defaultEnv.default;
    }
  }

  // IF an environment is given, use it, merge with default and store
  // set the local to this file env-variable
  if (localEnvironmentConfig) {
    Object.keys(localEnvironmentConfig).forEach((env) => {
      if (localEnvironmentConfig[env].hostname === window.location.hostname) {
        current.push(env);
      }
    });

    if (window.location.search.indexOf('debug=1') > -1) {
      current.push('debug');
    }

    current.forEach((env) => {
      configurations.push(localEnvironmentConfig[env]);
    });

    environments = Object.assign({}, localEnvironmentConfig.default, ...configurations);
    window.agsw = window.agsw || {};
    window.agsw.environment = environments;
  }
}

export default {
  initialize,
  get,
  is,
  getNames,
  isDevelopment,
  isLocal,
  isTest,
  isStage,
  isProduction,
};
